/*
    Don't reuse this component!
    Elements of this have been switched from dyanmic to static. This component has been specifically edited to fit this site.
*/
import React from "react";
import { Helmet } from "react-helmet";
import favicon from '../images/favicon/favicon.ico'
import metaImage from '../images/meta.webp'

const SearchEngineOptimisation = ({ title, description, path, keywords, children, index = true, schemaMarkup }) => {
    const siteName = 'How Much Data Is That'
    const siteUrl = 'https://human.games/how-much-data-is-that'
    const pageUrl = `${siteUrl}${path}`

    return (
        <Helmet htmlAttributes={{
            lang: 'en',
        }}>
            
            <meta charSet="utf-8" />
            <meta name="language" content="en" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />

            <meta http-equiv="Content-type" content="text/html; charset=UTF-8" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <meta name="referrer" content="origin" />

            <title>{title}</title>
            <link rel="icon" href={favicon} />

            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={metaImage} />
            <meta property="og:url" content={`${pageUrl}?utm_source=social&utm_id=social`} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={siteName} />

            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={metaImage} />
            <meta name="twitter:url" content={`${pageUrl}?utm_source=twitter&utm_id=social`} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content={siteName} />
            <meta name="twitter:domain" content={siteUrl} />

            {/* Disallow Robots to index site is index is set to false */}
            {!index &&
                <meta name="robots" content="noindex" />
            }
            {!index &&
                <meta name="googlebot" content="noindex" />
            }
            {!index &&
                <meta name="googlebot-news" content="noindex" />
            }
            {!index &&
                <meta name="googlebot" content="noindex" />
            }
            {!index &&
                <meta name="googlebot-news" content="nosnippet" />
            }

            {/* Add schemaMarkup is provided */}
            {schemaMarkup && <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>}

            {children}

        </Helmet>
    )
}

export default SearchEngineOptimisation